// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"40":"d9e2c2f3","365":"8939707b","818":"d1b9c906","987":"9e2c636e"}[chunkId] + ".js";
};